import { Formik } from "formik"
import { useEffect, useState } from "react"
import { Card, Col, Modal, Row } from "react-bootstrap"
import { useHistory, useLocation } from "react-router-dom"
import * as Yup from "yup"
import { SeleksiVendorAsetApi } from "../../../api"
import {
  ActionButton,
  Alert,
  BackButton,
  DataStatus,
  TextArea
} from "../../../components"
import { FormPermintaanAsetContent } from "./SeleksiVendorAsetComps"
import { formInitialValues } from "./SeleksiVendorAsetUtils"
import { GuestMiddleware } from "utilities"

const DetailSeleksiVendorAset = ({ setNavbarTitle }) => {
  const history = useHistory()
  const { state } = useLocation()
  const no_seleksi_vendor_aset = state?.no_seleksi_vendor_aset
  const tab = state?.tab ?? ""
  const [isPageLoading, setIsPageLoading] = useState(false)
  const [isFetchingFailed, setIsFetchingFailed] = useState(false)
  const [dataDeliveryOrder, setDataDeliveryOrder] = useState([])
  const [approveStatus, setApproveStatus] = useState("V")
  const [modalConfig, setModalConfig] = useState({
    show: false,
    type: "",
    title: ""
  })
  const [alertConfig, setAlertConfig] = useState({
    show: false,
    variant: "primary",
    text: ""
  })

  const getInitialData = () => {
    setIsPageLoading(true)

    SeleksiVendorAsetApi.getSingle({
      no_seleksi_vendor_aset: no_seleksi_vendor_aset
    })
      .then(({ data }) => {
        const behavior = data.data.behavior ? data.data.behavior : "V"
        setDataDeliveryOrder(data.data)
        setApproveStatus(behavior.toUpperCase())
      })
      .catch(() => {
        setIsFetchingFailed(true)
        setAlertConfig({
          show: true,
          variant: "danger",
          text: "Data gagal dimuat!"
        })
      })
      .finally(() => setIsPageLoading(false))
  }

  const whenNoSuratJalan = () => {
    setIsPageLoading(false)
    setIsFetchingFailed(true)
  }

  const formSubmitHandler = (values) => {
    const today = new Date().toISOString().slice(0, 10)

    const checkStatus = () => {
      if (modalConfig.type === "revise") {
        return "REV"
      }

      if (modalConfig.type === "approve") {
        return "APP"
      }

      if (modalConfig.type === "reject") {
        return "REJ"
      }
    }

    const finalValues = {
      no_transaksi: no_seleksi_vendor_aset,
      status_approval: checkStatus(),
      catatan: values.catatan,
      tgl_approval: today,
      approval_baseline: dataDeliveryOrder.detail.baseline
    }

    SeleksiVendorAsetApi.approve(finalValues)
      .then(() =>
        history.push("/human-resource/approval/seleksi-vendor-aset", {
          alert: {
            show: true,
            variant: "primary",
            text: `Approval berhasil disimpan!`
          }
        })
      )
      .catch(() =>
        setAlertConfig({
          show: true,
          variant: "danger",
          text: "Approval gagal disimpan!"
        })
      )
      .finally(() => {
        setModalConfig({
          ...modalConfig,
          show: false
        })
        getInitialData()
      })
  }

  useEffect(() => {
    setNavbarTitle("Approval Seleksi Vendor Aset")
    getInitialData()
    // no_seleksi_vendor_aset ? getInitialData() : whenNoSuratJalan();

    return () => {
      setIsPageLoading(false)
    }
  }, [])

  const ModalSection = ({ formik }) => {
    const { values, isSubmitting, handleSubmit } = formik

    const ModalContent = () => (
      <>
        <Modal.Body className="text-center">
          <h6>
            <b>
              {modalConfig.title === "approve"
                ? approveStatus === "A"
                  ? "Approve"
                  : "Verify"
                : modalConfig.title}{" "}
              dengan catatan :
            </b>
          </h6>
          <span>{values.catatan}</span>
        </Modal.Body>
        <Modal.Footer className="justify-content-center">
          <ActionButton
            variant="outline-secondary"
            text="Batal"
            className="px-4"
            onClick={() =>
              setModalConfig({
                ...modalConfig,
                show: false
              })
            }
          />
          <ActionButton
            text={
              modalConfig.type === "approve"
                ? approveStatus === "A"
                  ? "Approve"
                  : "Verify"
                : modalConfig.type
            }
            variant={
              modalConfig.type === "approve"
                ? "success"
                : modalConfig.type === "revise"
                ? "warning"
                : "danger"
            }
            className="m-1 px-3 text-white"
            onClick={handleSubmit}
            loading={isSubmitting}
          />
        </Modal.Footer>
      </>
    )

    return (
      <Modal
        show={modalConfig.show}
        onHide={() =>
          setModalConfig({
            ...modalConfig,
            show: false
          })
        }>
        <Modal.Header closeButton className="py-2 d-flex align-items-center">
          <Modal.Title>
            <small>{modalConfig.title}</small>
          </Modal.Title>
        </Modal.Header>
        <ModalContent />
      </Modal>
    )
  }

  const FormCard = ({ formik }) => {
    const { values, errors, touched, dirty, validateForm, handleChange } =
      formik
    const dataPengaju = dataDeliveryOrder?.approval
      ? dataDeliveryOrder.approval
      : []

    const InfoItem = ({ title1, value1, title2, value2 }) => (
      <div className="mb-2">
        <small>{title1}</small>
        <br />
        <b>{value1}</b>
        <div className="mt-1" />
        <small>{title2}</small>
        <br />
        <b>{value2}</b>
      </div>
    )

    return (
      <Card className="mt-4 mb-5">
        <Card.Header className="d-flex justify-content-between align-items-center">
          <b>Approval Detail Seleksi Vendor Aset</b>
        </Card.Header>
        <Card.Body>
          <Row>
            {dataPengaju.map((val, index) => (
              <Col sm>
                <InfoItem
                  title1={
                    val.status_approval == "VER"
                      ? `Pemeriksa ${val.approval_level}`
                      : "Pengesah"
                  }
                  value1={val.nama_karyawan ?? "-"}
                  title2="Catatan"
                  value2={val.catatan ?? "-"}
                />
              </Col>
            ))}
          </Row>
          {dataPengaju.length > 1 && <hr />}
          {tab !== "history" && (
            <div>
              <TextArea
                label="Catatan"
                name="catatan"
                placeholder="Masukan catatan"
                value={values.catatan}
                onChange={handleChange}
                error={errors.catatan && true}
                errorText={errors.catatan}
              />
              <div className="d-flex justify-content-end mt-3">
                {approveStatus === "A" ? (
                  <>
                    <ActionButton
                      text="Reject"
                      variant="danger"
                      className="m-1"
                      onClick={() => {
                        if (dirty) {
                          setModalConfig({
                            show: true,
                            type: "reject",
                            title: (
                              <span className="text-danger">
                                Reject Detail Seleksi Vendor Aset
                              </span>
                            )
                          })
                        }

                        validateForm()
                      }}
                    />
                    <ActionButton
                      text={approveStatus === "A" ? "Approve" : "Verify"}
                      variant="success"
                      className="m-1"
                      onClick={() => {
                        if (dirty) {
                          setModalConfig({
                            show: true,
                            type: "approve",
                            title: (
                              <span className="text-success">
                                {approveStatus === "A" ? "Approve" : "Verify"}{" "}
                                Detail Seleksi Vendor Aset
                              </span>
                            )
                          })
                        }

                        validateForm()
                      }}
                    />
                  </>
                ) : (
                  <>
                    <ActionButton
                      text="Reject"
                      variant="danger"
                      className="m-1"
                      onClick={() => {
                        if (dirty) {
                          setModalConfig({
                            show: true,
                            type: "reject",
                            title: (
                              <span className="text-danger">
                                Reject Detail Seleksi Vendor Aset
                              </span>
                            )
                          })
                        }

                        validateForm()
                      }}
                    />
                    <ActionButton
                      text="Revise"
                      variant="warning"
                      className="m-1 text-white"
                      onClick={() => {
                        if (dirty) {
                          setModalConfig({
                            show: true,
                            type: "revise",
                            title: (
                              <span className="text-warning">
                                Revise Detail Seleksi Vendor Aset
                              </span>
                            )
                          })
                        }

                        validateForm()
                      }}
                    />
                    <ActionButton
                      text={approveStatus === "A" ? "Approve" : "Verify"}
                      variant="success"
                      className="m-1"
                      onClick={() => {
                        if (dirty) {
                          setModalConfig({
                            show: true,
                            type: "approve",
                            title: (
                              <span className="text-success">
                                {approveStatus === "A" ? "Approve" : "Verify"}{" "}
                                Detail Seleksi Vendor Aset
                              </span>
                            )
                          })
                        }

                        validateForm()
                      }}
                    />
                  </>
                )}
              </div>
            </div>
          )}
        </Card.Body>
      </Card>
    )
  }

  return (
    <>
      <div className="d-flex justify-content-between">
        <b>Detail Data Seleksi Vendor Aset</b>
        <BackButton onClick={() => history.goBack()} />
      </div>

      <Alert
        showCloseButton
        show={alertConfig.show}
        variant={alertConfig.variant}
        text={alertConfig.text}
        onClose={() =>
          setAlertConfig({
            ...alertConfig,
            show: false
          })
        }
      />

      {isPageLoading ? (
        <DataStatus loading={true} text="Memuat data . . ." />
      ) : isFetchingFailed ? (
        <DataStatus text="Data gagal dimuat!" />
      ) : (
        <>
          <Formik initialValues={formInitialValues(dataDeliveryOrder?.detail)}>
            <FormPermintaanAsetContent action="detail" />
          </Formik>
        </>
      )}

      {!isFetchingFailed && !isPageLoading && (
        <Formik
          initialValues={{
            catatan: ""
          }}
          validationSchema={Yup.object().shape({
            catatan: Yup.string().required("Masukan catatan")
          })}
          onSubmit={formSubmitHandler}>
          {(formik) => (
            <>
              <GuestMiddleware>
                <FormCard formik={formik} />
              </GuestMiddleware>
              <ModalSection formik={formik} />
            </>
          )}
        </Formik>
      )}
    </>
  )
}

export default DetailSeleksiVendorAset
